<template>
  <v-bottom-sheet
      v-model="sheet"
      scrollable
      persistent
      no-click-animation
      :overlay-opacity="0.7"
      content-class="bottom-sheet"
  >
    <v-card>
      <SheetHeader :title="title[flag]" @sheetClose="$emit('sheetClose')"/>
      <v-card-text :style="[flag === 1 ? {height:`${height}`} : {height:'auto'}]" class="sheet-body" ref="sheetBody">
        <!-- 가장 건강한 나무 -->
        <div v-if="flag === 0" class="text-center">
          <div class="tree-area mb-7">
            <v-img :src="treeUrl" max-height="200" contain></v-img>
          </div>
          <div class="fs-16 fw-600 black--text mb-4">{{ treeName }}</div>
          <div class="fs-16 black--text description">
            <span class="text-no-wrap primaryLight primary--text fw-600 pa-1">튼튼한 기둥, 많은 가지, 풍성하며 푸른 잎,</span><br>
            <span class="text-no-wrap primaryLight primary--text fw-600 pa-1">풀이난 토양</span>으로 이루어진<br>건강한 나무에요!
          </div>
        </div>
        <!-- 날씨 감정 -->
        <div v-else-if="flag === 1">
          <div class="text-center pt-4 pb-5">
            <EmotionIocn v-if="isSamsungFire" :state="emotionStatCode"/>
            <StateIocn v-else :state="emotionStat"/>
            <div class="fs-20 fw-600 black--text mt-3">{{ emotionStat }}</div>
          </div>
          <div
              v-for="n in templateDescription.length"
              :key="n"
              class="mt-6"
          >
            <div class="fs-16 fw-600 black--text ps-1 mb-2">{{ templateDescription[n - 1].title }}</div>
            <ul class="list dot">
              <li v-for="i in templateDescription[n-1].description.length" :key="i">
                {{ templateDescription[n - 1].description[i - 1] }}
              </li>
            </ul>
          </div>
        </div>
        <!-- 나무 감정 -->
        <div v-else-if="flag === 2">
          <div class="text-center pt-4 pb-5">
            <!-- 아이콘이없어 자리만.. -->
            <span v-if="isSamsungFire" style="display:inline-block; width:70px;height:70px; border-radius: 50%; background: #e3e3e3;">
                <img :src="getImage(treeEmotionSrc)" style="width:70px; height:70px;">
            </span>
            <StateIocn v-else :state="emotionStat"/>
            <div class="fs-20 fw-600 black--text mt-3">{{ emotionStat }}</div>
          </div>
          <div
              v-for="n in templateDescription.length"
              :key="n"
              class="mt-6"
          >
            <div class="fs-16 fw-600 black--text ps-1 mb-2">{{ templateDescription[n - 1].title }}</div>
            <ul class="list dot">
              <li v-for="i in templateDescription[n-1].description.length" :key="i">
                {{ templateDescription[n - 1].description[i - 1] }}
              </li>
            </ul>
          </div>
        </div>
      </v-card-text>
    </v-card>

  </v-bottom-sheet>
</template>
<script>
import {mixinAuth} from '@/mixins'
import SheetHeader from "./SheetHeader";
import EmotionIocn from "@/components/icons/EmotionIocn";
import StateIocn from "@/components/icons/StateIocn";

export default {
  props: {
    flag: Number,
    sheet: Boolean,
    height: String
  },
  components: {
    SheetHeader,
    EmotionIocn,
    StateIocn
  },
  mixins: [mixinAuth],
  data: () => ({
    treeName: '인피니티 나무',
    treeUrl: require('@/assets/images/tree/ic_tree32.svg'),
    title: ['가장 건강한 나무의 모습은?', '우울', '자아강동'],
    templateDescription: [
      {title: "지금 상태는?", description: null},
      {title: "이렇게 해보세요!", description: null},
    ],
    emotionStat: '',
    emotionStatCode: 0,
    treeEmotionSrc: ''
  }),
  methods: {
    setSheetData(setSheetData, viewFlag) {
      this.templateDescription[0].description = setSheetData.statusItpt.split('|');      // 상태 해석
      this.templateDescription[1].description = setSheetData.copeMethod.split('|');      // 대처 방법
      this.emotionStat = setSheetData.state;
      this.title[viewFlag] = setSheetData.emotion;
      this.treeEmotionSrc = setSheetData.icon;

      let colorCode = 0;
      if (this.emotionStat === "안정") {
        colorCode = 0;
      } else if (this.emotionStat === "주의") {
        colorCode = 1;
      } else if (this.emotionStat === "위험") {
        colorCode = 2;
      }
      this.emotionStatCode = colorCode;
      setTimeout(() => {
        this.$refs.sheetBody.scrollTo({top: 0});
      }, 100);
    },

  }
};
</script>

<!--<style lang="scss" scoped>-->
<!--::v-deep .v-dialog{-->
<!--    .sheet-body{-->
<!--        padding: 30px 23px;-->
<!--        .tree-area{-->
<!--            height:280px;-->
<!--            display: flex;-->
<!--            justify-content: center;-->
<!--            align-items: center;-->
<!--            background: #f8f8f8;-->
<!--            border-radius: 10px;-->
<!--        }-->
<!--        .description{-->
<!--            line-height: 25px;-->
<!--        }-->
<!--    }-->
<!--}-->

<!--</style>-->
